import { Box, Typography } from "@mui/material";
import theme from "../../../../../theme";
import { getCommaFormattedNumber } from "../../../../../utils/methods/stringMethods";

const ReservePriceOrNearReserverPriceCard = ({
  car,
  highestBid
}) => {
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: '1.25rem', // Rounded corners for the main card
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem', // Space between the two inner boxes
        width: '100%', // Take full width of parent
        boxShadow: '0rem 0.25rem 0.625rem rgba(0, 0, 0, 0.1)', // Subtle shadow
      }}
    >
      {/* Car Sold Section */}
      <Box
        sx={{
          backgroundColor: 'rgba(43, 210, 76, 0.1)', // Light green background (10% opacity of primary.green)
          border: `0.0625rem solid ${theme.palette.primary.green}`, // Green border
          borderRadius: '0.625rem', // Rounded corners
          padding: '1.5rem 1rem',
          display: 'flex',
          flexDirection: "column",
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="body1" // Use body1 variant for text
          sx={{
            color: theme.palette.primary.green, // Green text color
            fontWeight: 600, // Make text bold
            fontSize: '1.125rem', // Custom font size for this text
          }}
        >
          {parseInt(car?.Reserve_Price) <= highestBid?.Bid_Amount ? (
            "Reserve price met."
          ) : (
            "Near reserve price."
          )}
          
        </Typography>

        {/* <Typography
          variant="body1" // Use body1 variant for text
          sx={{
            color: theme.palette.primary.green, // Green text color
            fontWeight: 600, // Make text bold
            fontSize: '1.125rem', // Custom font size for this text
          }}
        >
          Current Highest bid: ${getCommaFormattedNumber(highestBid?.Bid_Amount)}
        </Typography> */}
      </Box>
    </Box>
  );
};

export default ReservePriceOrNearReserverPriceCard;